import { executeOps } from "./office-ops.ts";

export type SlideImage = { base64: string; mediaType: string };

const cache = new Map<string, SlideImage>();
const inflight = new Map<string, Promise<SlideImage>>();

const cacheKey = (slide: number, width?: number, height?: number): string =>
  `${String(slide)}:${String(width ?? "")}x${String(height ?? "")}`;

export const fetchSlideImage = (
  slide: number,
  opts?: { width?: number; height?: number },
): Promise<SlideImage> => {
  const key = cacheKey(slide, opts?.width, opts?.height);
  const hit = cache.get(key);
  if (hit) return Promise.resolve(hit);
  const pending = inflight.get(key);
  if (pending) return pending;
  const p = executeOps([
    { op: "getSlideImage", slide, width: opts?.width, height: opts?.height },
  ]).then((results) => {
    const raw = results[0];
    if (typeof raw !== "object" || raw === null) throw new Error("getSlideImage failed");
    let base64 = "";
    let mediaType = "";
    for (const [k, v] of Object.entries(raw)) {
      if (k === "base64" && typeof v === "string") base64 = v;
      if (k === "mediaType" && typeof v === "string") mediaType = v;
    }
    if (!base64 || !mediaType) throw new Error("getSlideImage missing fields");
    const c: SlideImage = { base64, mediaType };
    cache.set(key, c);
    inflight.delete(key);
    return c;
  });
  inflight.set(key, p);
  return p;
};
